<template>
  <b-form novalidate @submit.prevent="handleSubmit">
    <b-modal
      v-model="open"
      :title="title"
      :ok-disabled="depositPhotoSettingsLoading"
      @ok.prevent="onOk"
      @cancel="onCancel"
      @close="onCancel"
    >
      <b-alert
        v-if="depositPhotoSettingsError"
        show
        variant="danger"
        class="py-2"
      >
        Nao foi possivel carregar a configuracao das fotos do deposito.
      </b-alert>
      <OperationForm
        ref="form"
        v-model="form"
        :type="type"
        :deposit-photo-settings="depositPhotoSettings"
        @submit="onSubmit"
      />
    </b-modal>
  </b-form>
</template>

<script>
import { OPERATION_CATEGORIES, OPERATION_TYPES } from '@/constants'
import { parseOperation } from '@/helpers/checkouts'
import services from '@/services'
import OperationForm from './OperationForm'

export default {
  name: 'CheckoutModal',
  components: {
    OperationForm
  },
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: String,
      required: true
    },
    checkout: {
      type: Object,
      default: () => ({})
    },
    operation: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      depositPhotoSettings: null,
      depositPhotoSettingsLoading: false,
      depositPhotoSettingsError: false,
      form: {
        amount: 0,
        type: null,
        category: OPERATION_CATEGORIES.MANUAL,
        name: '',
        receiptPhoto: null,
        receiptPhotoUrl: null
      }
    }
  },
  computed: {
    open: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    },
    isRevenue() {
      return this.type === OPERATION_TYPES.REVENUE
    },
    title() {
      if (this.operation) {
        return this.isRevenue ? 'Editar Entrada' : 'Editar Saida'
      }

      return this.isRevenue ? 'Nova Entrada' : 'Nova Saida'
    }
  },
  watch: {
    open: {
      immediate: true,
      handler(value) {
        if (value) this.loadDepositPhotoSettings()
      }
    },
    type(newType) {
      this.form.type = newType
    },
    operation: {
      immediate: true,
      handler(operation) {
        this.hydrateForm(operation)
      }
    }
  },
  methods: {
    async loadDepositPhotoSettings() {
      if (this.type !== OPERATION_TYPES.EXPENSE || !this.checkout?.storeId) {
        this.depositPhotoSettings = null
        return
      }

      this.depositPhotoSettingsLoading = true
      this.depositPhotoSettingsError = false

      try {
        const store = await services.stores.fetchStoreById(
          this.checkout.storeId
        )
        this.depositPhotoSettings = {
          hasDepositPhotos: Boolean(store.hasDepositPhotos),
          isDepositPhotoRequired: Boolean(store.isDepositPhotoRequired)
        }
      } catch (error) {
        this.depositPhotoSettings = null
        this.depositPhotoSettingsError = true
      } finally {
        this.depositPhotoSettingsLoading = false
      }
    },
    onOk() {
      if (this.depositPhotoSettingsLoading) return
      this.$refs.form.handleSubmit()
    },
    onCancel() {
      this.$emit('cancel')
    },
    formatMoneyInput(amount) {
      return Number(amount || 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    hydrateForm(operation) {
      this.form = {
        checkoutId: operation?.checkoutId || this.checkout?.id || null,
        paymentId: operation?.paymentId || null,
        amount: operation ? this.formatMoneyInput(operation.amount) : 0,
        type: this.type,
        category: operation?.category || OPERATION_CATEGORIES.MANUAL,
        name: operation?.name || '',
        receiptPhoto: null,
        receiptPhotoUrl: operation?.receiptPhotoUrl || null
      }
    },
    onSubmit() {
      const parsedOperation = parseOperation(this.form)
      if (this.operation?.id) {
        parsedOperation.id = this.operation.id
      }
      this.$emit('ok', parsedOperation)
    }
  }
}
</script>
